<div [formGroup]="phoneFormGroup" class="form-outline">
    <input id="phoneElement" type="tel" formControlName="phone" (input)="onInputChanged()" class="form-control w-100" 
    [ngClass]="{'error-field': !isValid && phone.touched}" />
    <span *ngIf="!isValid && phone.touched" class="error-text"> {{ validationService.getValidationErrorMessage(phone) }}</span>

</div>